const badges = [0,10,25,50,100]

export default badges